<template>
  <div class="readonly-banner">
    <v-icon icon="mdi-laptop" size="18" class="readonly-banner__icon" />
    <span class="readonly-banner__text">{{ text }}</span>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: "Read-only on mobile — open on desktop to edit or take action.",
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.readonly-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: rgba($lh_color_blue, 0.08);
  border: 1px solid rgba($lh_color_blue, 0.16);
}

.readonly-banner__icon {
  color: $lh_color_blue;
  flex-shrink: 0;
}

.readonly-banner__text {
  font-size: 13.5px;
  line-height: 18px;
  font-weight: 500;
  color: $lh_color_navy;
}
</style>
